import { schemas } from '@convergence/client';
import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';
import { fetch } from '../fetch';

const UpdateLabMemberBodySchema = z.object({
  role: z.string(),
  labMemberId: z.number()
});
type UpdateLabMemberBody = z.infer<typeof UpdateLabMemberBodySchema>;

export async function updateLabMember(data: UpdateLabMemberBody) {
  return fetch(
    `/lab-member/${data.labMemberId}`,
    { method: 'PATCH', body: JSON.stringify({ role: data.role }) },
    schemas.UpdateLabMemberResponse
  );
}

export const useUpdateLabMemberMutation = () => {
  return useMutation({
    mutationKey: ['updateLabMember'],
    retry: false,
    mutationFn: async (data: UpdateLabMemberBody) => {
      const result = updateLabMember(data);
      return result;
    }
  });
};

